import Page from "./Page";


export default (props:any)=>{
    return(
        <Page>
            <h3 style={{color: "red",fontStyle:"italic",fontSize:34}}>Not found page</h3>
        </Page>
    )
}